import { getChinaAndroidTrialProductId } from '@forest/paywall-core'
import { api } from '~/services/api'
import { platform } from '~/params'
import { $chinaAndroidTrialEligibility } from '~/store'

const CHINA_ANDROID_TRIAL_PRODUCT_ID = getChinaAndroidTrialProductId(
  import.meta.env.MODE,
)

interface OwnPurchaseStatsResponse {
  stats: {
    month_count: number
    today_count: number
    total_count: number
  }
}

export async function getChinaAndroidTrialEligibility(
  userId: number,
): Promise<'available' | 'unavailable'> {
  if (platform !== 'china_android' || !CHINA_ANDROID_TRIAL_PRODUCT_ID) {
    $chinaAndroidTrialEligibility.set('unavailable')
    return 'unavailable'
  }

  try {
    const response = await api.service
      .get(
        `store/users/${userId}/product/${CHINA_ANDROID_TRIAL_PRODUCT_ID}/own-purchase-stats`,
      )
      .json<OwnPurchaseStatsResponse>()

    const eligibility =
      response.stats.total_count > 0 ? 'unavailable' : 'available'
    $chinaAndroidTrialEligibility.set(eligibility)
    return eligibility
  } catch {
    $chinaAndroidTrialEligibility.set('unavailable')
    return 'unavailable'
  }
}
